export const isValidOmanMobile = (number) => {
  const cleaned = number.replace(/\s+/g, ""); // Remove spaces

  // With country code
  if (/^(?:\+968|968)[79]\d{7}$/.test(cleaned)) {
    return { isValid: true };
  }

  // Without country code
  if (/^[79]\d{7}$/.test(cleaned)) {
    return { isValid: true };
  }

  return { isValid: false, errMsg: "Please enter a valid Oman mobile number" };
};